import React from 'react'
import type { SingleSessionResult } from '@mc/api'
import { ActiveParticipationSection } from 'pages/sessions/shared/ActiveParticipationSection'
import { TimelineSection } from 'pages/sessions/shared/TimelineSection'
import { getInstructorTitle } from 'pages/sessions/utils'
import type { Camp } from '../../types'
import { CampPointers } from '../CampPointers'
import { Curriculum } from '../Curriculum'
import { FeaturedProjects } from '../FeaturedProjects'
import { InlineTrailer } from '../InlineTrailer'
import { InstructorBio } from '../InstructorBio'
import { SkillSection } from '../SkillSection'
import { SpecialPartnership } from '../SpecialPartnership'

export const CampContent = ({
  camp,
  session,
  onOverviewClick,
}: {
  camp: Camp
  session: SingleSessionResult
  onOverviewClick: () => void
}) => {
  const timelineModules = camp.modules?.map(({ id, name, marketing3x2 }) => ({
    id,
    name,
    marketing3x2,
  }))

  return (
    <div className='container'>
      <CampPointers camp={camp} />

      <InlineTrailer camp={camp} />

      {camp.isLive && (
        <div data-testid='live-enroll-components'>
          <SpecialPartnership />
          <TimelineSection featuredSession={{ modules: timelineModules }} />
          <SkillSection competencies={camp.competencies || []} />
          <Curriculum
            modules={camp.modules}
            onOverviewClick={onOverviewClick}
          />
          <FeaturedProjects projects={session.campFeaturedProjects} />

          <ActiveParticipationSection />

          {camp.images.nameplateImage && (
            <InstructorBio
              campSlug={camp.slug}
              nameplate={camp.images.nameplateImage}
              instructorTitle={getInstructorTitle(camp?.instructors)}
            />
          )}
        </div>
      )}
    </div>
  )
}
